import Navbar from "@components/layout/Navbar";
import ConsultationRecorder from "@pages/ConsultationRecorder";

/**
 * The frontdesk surface with its header. `/voice` used to render
 * ConsultationRecorder bare while the home route wrapped the same page in the
 * Navbar for voice users, so the one link that pointed at `/voice` (the
 * Reactivation tab row) landed on a page with no header. One wrapper, both
 * entrances.
 */
export default function VoicePage() {
  return (
    <div className="flex flex-col h-screen">
      <div className="sticky top-0 z-40">
        <Navbar selected="Consultation Recorder" showTabs={false} showFieldSearch={false} />
      </div>
      <ConsultationRecorder />
    </div>
  );
}
